// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState, Dispatch, SetStateAction } from "react"


function useLocalState<S>(k: string, initial: any): [S, Dispatch<SetStateAction<S>>] {
  const value = (!!localStorage.getItem(k))
    ? JSON.parse(localStorage.getItem(k) || "null")
    : initial
  const [state, setState] = useState<S>(value)

  useEffect(() => {
    localStorage.setItem(k, JSON.stringify(state))
  }, [k, state])

  return [state, setState]
}

export default useLocalState